import React, { Component } from "react";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import {
  disableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
import Picker from "react-mobile-picker";
import classes from "./Picker.module.css";

export default class BirthPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTypePickerShow: false,
      valueType: {
        title: "...",
      },
      optionTypes: {
        title: [
          "...",
          "1.50 PGC",
          "1.50 Lutina SPS",
          "1.50 TBC (BlueControl)",
          "1.60 SPS",
          "1.60 TBC AS (BlueControl)",
          "1.60 DFC AS (AntiFog)",
          "1.70 SPS AS",
          "1.76 SPS AS",
        ],
      },
      currentTransform: -54
    };
    this.targetElement = null;
  }

  componentDidMount() {
    this.targetElement = document.querySelector("#root");
    // const scrollers = document.getElementsByClassName("picker-scroller");
    // // var currentPosition;
    // var nextPosition;
    // let lastChild;
    // for (let scroller of scrollers){
    //   const parentParent = scroller.parentNode.parentNode;
    //   const parent = scroller.parentNode;
    //   const parentIndex = Array.from(parentParent.children).indexOf(parent);
    //   if (parentIndex === 2){
    //     // currentPosition = parseInt(scroller.style.transform.split(',')[1]);
    //     nextPosition = parseInt(scroller.style.transform.split(',')[1]);
    //   }
    //   scroller.addEventListener('touchmove', function(event) {
    //     // event.preventDefault();
    //     if (parentIndex === 2){
    //       nextPosition = parseInt(scroller.style.transform.split(',')[1]);
    //       if (30 < nextPosition) {
    //         lastChild = scroller.lastChild;
    //         scroller.prepend(lastChild);
    //       } 
    //     }
    //   });
    // }
  }
  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }
  handleTypeChange = (name, value) => {
    this.setState(({ valueType, optionTypes }) => {
      const nextState = {
        valueType: {
          ...valueType,
          [name]: value,
        },
      };
      return nextState;
    });
  };

  togglePicker = (mode) => {
    !this.state.isTypePickerShow ? disableBodyScroll(this.targetElement) : clearAllBodyScrollLocks();
    this.setState(
      ({ isTypePickerShow }) => ({
        isTypePickerShow: !isTypePickerShow,
      }),
      () => {
        const data = {
          side: this.props.title,
          type: this.state.valueType.title.replace(" ", "")
        };
        !this.state.isTypePickerShow && this.props.onSelect(data);
        this.state.isTypePickerShow && this.props.onToggle(this.props.title);
      })
  };

  render() {
    const { isTypePickerShow, optionTypes, valueType } = this.state;
    const maskTypeStyle = {
      display: isTypePickerShow ? "block" : "none",
    };
    const pickerModalTypeClass = `picker-modal${
      isTypePickerShow ? " picker-modal-toggle" : ""
    }`;

    const { data } = this.props;
    const sphere = data.power.split(' ')[0];
    const cylinder = data.power.split(' ')[1];
    return (
      <div className={this.props.isExist + " example-container"}>
        <div className="weui_cells_title">{this.props.title} :</div>
        <div className="weui_cells">
          <div className="weui_cell weui_cell_select weui_select_after">
            <div className="signSphereCylinder title">
              <span>نوع عدسی</span>
            </div>
            <div className="signSphereCylinder border-rounded">
              <p
                type="text"
                dir="ltr"
                className={classes.PickerBox}
                readOnly
                onClick={() => this.togglePicker("type")}
              >
                <span className="lensType">{valueType.title}</span>
              </p>
            </div>
            <div className="signSphereCylinder title hasLine">
              <span>اسفر</span>
              <span>سیلندر</span>
              <span>تعداد</span>
            </div>
            <div className="signSphereCylinder border-rounded">
              <p
                type="text"
                dir="ltr"
                className={classes.PickerBox}
                onClick={() => this.props.onToggle(this.props.title === 'چشم راست' ? 'right' : 'left')}
                readOnly
              >
                <span className="translate">
                  {sphere}
                </span>
                <span className="translate">
                  {cylinder}
                </span>
                <span>{this.props.data.count}</span>
              </p>
            </div>
            <div className="signSphereCylinder line">
              <span></span>
            </div>
            {this.props.isExist === "exist" && (
              <p className="text-center">
                <CheckIcon /> موجود است
              </p>
            )}
            {this.props.isExist === "not-exist" && (
              <p className="text-center">
                <ClearIcon /> موجود نیست
              </p>
            )}
          </div>
        </div>
        <div className="picker-modal-container">
          <div
            className="picker-modal-mask"
            style={maskTypeStyle}
            onClick={() => this.togglePicker("type")}
          ></div>
          <div className={pickerModalTypeClass}>
            <header>
              <div className="title">نوع عدسی را انتخاب کنید</div>
              <button onClick={() => this.togglePicker("type")}>تایید</button>
            </header>
            <Picker
              optionGroups={optionTypes}
              valueGroups={valueType}
              onChange={this.handleTypeChange}
            />
          </div>
        </div>
      </div>
    );
  }
}
